<template>
	<div class="tabStatistics">
		<div class="fieldGroup">
			<div class="groupFieldTitle">
				<span>Statistics</span>
			</div>
			<div class="groupField_wrap">
				<div class="groupField_row">
					<field
							margin="10px 10px 0 0"
							width="240px"
							label="Dispatch manager"
							placeholder="Select dispatch manager"
							@updateSelect="onSelect($event, 'selectedSft')"
							:autocompleteValue="selectedSft"
							:items="dispatcher"
							:isClearable="false"
							is-select
							item-text="personal_name"
							item-value="employee_id"
							is-required
					></field>
					<field
							margin="10px 10px 0 0"
							width="240px"
							label="Phone"
							:setInputValue="selectedSftPhone"
							isReadonly
					></field>
				</div>
				<div class="groupField_row">
					<field
							margin="10px 10px 0 0"
							width="240px"
							label="Safety Manager"
							placeholder="Select safety Manager"
							@updateSelect="onSelect($event, 'selectedMgr')"
							:autocompleteValue="selectedMgr"
							:items="dispatcher"
							:isClearable="false"
							is-select
							item-text="personal_name"
							item-value="employee_id"
							is-required
					></field>
					<field
							margin="10px 10px 0 0"
							width="240px"
							label="Phone"
							:setInputValue="selectedMgrPhone"
							isReadonly
					></field>
				</div>
				<div class="groupField_row">
					<field
							margin="10px 10px 0 0"
							width="240px"
							label="Sales"
							placeholder="Select sales"
							@updateSelect="onSelect($event, 'selectedSls')"
							:autocompleteValue="selectedSls"
							:items="dispatcher"
							:isClearable="false"
							is-select
							item-text="personal_name"
							item-value="employee_id"
							is-required
					></field>
					<field
							margin="10px 10px 0 0"
							width="240px"
							label="Phone"
							:setInputValue="selectedSlsPhone"
							isReadonly
					></field>
				</div>
				<div class="groupField_row">
					<field
							:classError="getError()"
							margin="10px 10px 0 0"
							width="240px"
							label="Afterhours"
							@updateInput="onInput($event, 'afterHrs')"
							:setInputValue="afterHrs"
							is-required
							is-phone
					></field>
					<field
							margin="10px 10px 0 0"
							width="240px"
							label="Phone"
							:setInputValue="afterHrsPhone"
							isReadonly
					></field>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "Statistics",
	props: {
		valid: Object,
		dispatcher: Array,
		statistics: Array,
	},
	data: () => ({
		selectedSls: null,
		selectedMgr: null,
		selectedSft: null,
		afterHrs: null,
		selectedSlsPhone: null,
		selectedMgrPhone: null,
		selectedSftPhone: null,
		afterHrsPhone: null,
		statisticsResult: [],
	}),

	// statistics_data = [
	// 	{ selectedSls: {employee_id: 11, personal_name: "Ali Al-Gayyim", phone: "312-818-3426"} },
	// 	{ selectedMgr: {employee_id: 11, personal_name: "Ali Al-Gayyim", phone: "312-818-3426"} }
	//  { afterHrs: "111-222-3333" }
	//  { selectedSft: {employee_id: 11, personal_name: "Ali Al-Gayyim", phone: "312-818-3426"} }
	// ]

	methods: {
		getError() {
			return this.valid.afterHrsValidations?.$error;
		},
		onInput({ value }, key) {
			if ( key === 'afterHrs' ) {
				this.afterHrs = value;
				this.afterHrsPhone = value;
			}
			this.statistics.find(item => {
				if ( item.type === 'afterHrs' ) item.phone = value;
			});
			this.statisticsResult.find(item => {
				if ( item.afterHrs ) item.afterHrs = value;
			});
			this.$emit("updateStatisticsResult", { result: this.statisticsResult, afterHrs: this.afterHrs } );
		},
		onSelect({ value }, key) {
			const { employee_id, personal_name, phone } = value;
			this.statistics.find(item => {
				if ( item.type === key ) {
					item.employee_id = employee_id;
					item.name = personal_name;
					item.phone = phone;
				}
			});
			this.statisticsResult.find(item => {
				if ( item[key] ) item[key] = { employee_id: employee_id, personal_name: personal_name, phone: phone };
			});
			if ( key === 'selectedSls' ) {
				this.selectedSls = employee_id;
				this.selectedSlsPhone = phone;
			}
			if ( key === 'selectedMgr' ) {
				this.selectedMgr = employee_id;
				this.selectedMgrPhone = phone;
			}
			if ( key === 'selectedSft' ) {
				this.selectedSft = employee_id;
				this.selectedSftPhone = phone;
			}
			this.$emit("updateStatisticsResult", { result: this.statisticsResult, afterHrs: 'onSelect' });
		},
	},
	mounted() {
		this.statistics.map(item => {
			if ( item.type === 'selectedSls' ) {
				this.selectedSls = item.employee_id;
				this.selectedSlsPhone = item.phone;
				this.statisticsResult.push({ selectedSls: { employee_id: item.employee_id, personal_name: item.name, phone: item.phone } });
			}
			if ( item.type === 'selectedMgr' ) {
				this.selectedMgr = item.employee_id;
				this.selectedMgrPhone = item.phone;
				this.statisticsResult.push({ selectedMgr: { employee_id: item.employee_id, personal_name: item.name, phone: item.phone } });

			}
			if ( item.type === 'afterHrs' ) {
				this.afterHrs = item.phone;
				this.afterHrsPhone = item.phone;
				this.statisticsResult.push({ afterHrs: item.phone });
			}
			if ( item.type === 'selectedSft' ) {
				this.selectedSft = item.employee_id;
				this.selectedSftPhone = item.phone;
				this.statisticsResult.push({ selectedSft: { employee_id: item.employee_id, personal_name: item.name, phone: item.phone } });
			}
		});
	}

};
</script>

<style scoped>
.groupField_row {
	display: grid;
	grid-template-columns: 1fr 1fr;
}
</style>
